export enum CountryKey {
  MalaysiaUrl = 'my',
  MalaysiaCode = 'MYS',
  PhilippinesUrl = 'ph',
  PhilippinesCode = 'PHL',
}
